import { render } from "./cargoSlider.vue?vue&type=template&id=42fa0fa4&scoped=true"
import script from "./cargoSlider.vue?vue&type=script&lang=js"
export * from "./cargoSlider.vue?vue&type=script&lang=js"

import "./cargoSlider.vue?vue&type=style&index=0&id=42fa0fa4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fa0fa4"]])

export default __exports__